import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class EmployeeScheduleForm extends ObjetKForm {
  employeeId: number = 0
  workScheduleTemplateId: number = 0
  startDate: string = ''
  endDate?: string
  notes: string = ''

  static validationRules = {
    workScheduleTemplateId: combineRules(requiredRule('Le modèle horaire est obligatoire')),
    startDate: combineRules(requiredRule('La date de début est obligatoire'))
  }

  constructor(data?: Partial<EmployeeScheduleForm>) {
    super(data)
    if (data) {
      this.employeeId = data.employeeId ?? 0
      this.workScheduleTemplateId = data.workScheduleTemplateId ?? 0
      this.startDate = data.startDate ?? ''
      this.endDate = data.endDate
      this.notes = data.notes ?? ''
    }
  }
}
